<div class="netop-dialog-sub-title-subheader-container" [ngClass]="cssClass">
    <div class="row issues-health-subheader-raw">
        <ng-content></ng-content>
    </div>
</div>